import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import scroll from "vue-seamless-scroll";
import iView from "iview";
import axios from "axios";
import "iview/dist/styles/iview.css";
import store from "./store";
import animated from "animate.css";
import "babel-polyfill";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import MetaInfo from "vue-meta-info";
import "quill/dist/quill.snow.css";

Vue.use(scroll, { componentName: "scroll-seamless" });
Vue.use(scroll);
Vue.use(VueAwesomeSwiper);
Vue.use(iView);
Vue.use(animated);
Vue.use(MetaInfo);

let instance = null;

instance = axios.create({
  baseURL: "/api",
  timeout: 30000
});

Vue.prototype.$http = instance;

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  }
}).$mount("#app");
